@if (isDisplayable) {
    <div class="register">
        <span class="text">{{ "account-management.no-account" | translate }}</span>
        @if (!!redirectSignupUrl || redirectSignupUrl === '') {
            <a
                [routerLink]="'/register'"
                ariaLabelTranslate="{{ 'account-management.register' | translate }}"
                class="link"
            >
                {{ "account-management.register" | translate }}
            </a>
        } @else {
            <a
                [href]="redirectSignupUrl"
                ariaLabelTranslate="{{ 'account-management.register' | translate }}"
                class="link"
                [target]="redirectSignupTarget"
            >
                {{ "account-management.register" | translate }}
            </a>
        }
    </div>
}